/**
 * The Symagic Server Deployment entity.
 * @author Tom Verschoore de la Houssaije
 */
import { BreezeService } from '../../core/breeze.service';
/**
 * The Symagic Server Deployment entity.
 */
var Deployment = /** @class */ (function () {
    function Deployment() {
        /**
         * Holding Reference of demand
         * @private
         * @type {Entity}
         */
        this.demand = undefined;
    }
    Object.defineProperty(Deployment.prototype, "Demand", {
        /**
         * Gets the demand of the deployment.
         * @readonly
         * @type {Entity}
         */
        get: function () {
            // This is needed to override breeze.js navigation property.
            if (!this.demand && this.entityAspect && this.entityAspect.entityState.isDetached()) {
                return undefined;
            }
            return this.demand;
        },
        /**
         * Sets the demand of the deployment
         */
        set: function (value) {
            if (value && value !== this.demand && this.entityAspect.entityState.isAdded()) {
                this.Start = value['Start'];
                this.Finish = value['Finish'];
                this.Name = value['Name'];
                this.Effort = value['WorkUnit'];
                this.Color = value['Color'];
                this['SumFactor'] = value['SumFactor'];
            }
            this.demand = value;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * A remote method that plans the entity on the backend.
     * @param {boolean} [afterSave=false] When true, the method is invoked after the state of the entity is saved
     * otherwise the method is invoked before the state is saved.
     */
    Deployment.prototype.plan = function (afterSave) {
        if (afterSave === void 0) { afterSave = false; }
        BreezeService.invokeMethod(this, 'Plan', [], afterSave);
    };
    return Deployment;
}());
export { Deployment };
